var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArticolo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2557_64911",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2557_64911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.33203 12.2503V11.0837H9.33203V12.2503H2.33203ZM5.62786 9.42116L2.33203 6.12533L3.55703 4.87116L6.88203 8.16699L5.62786 9.42116ZM9.33203 5.71699L6.0362 2.39199L7.29036 1.16699L10.5862 4.46283L9.33203 5.71699ZM12.0154 11.667L4.40286 4.05449L5.21953 3.23783L12.832 10.8503L12.0154 11.667Z",
    fill: "#3B82F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArticolo);
export default __webpack_public_path__ + "static/media/icon_articolo.c5173c04f27022e06976129f53b8b5a0.svg";
export { ForwardRef as ReactComponent };